import UserList from './EnterpriseUserList';
import RoleList from './EnterpriseRoleList';

export default {
  UserList,
  RoleList,
};



// WEBPACK FOOTER //
// ./src/manage-modules/UserManage/index.js